export enum DevDemoTabs {
  Slider = '/dev-demo/slider',
  Nrs = '/dev-demo/nrs',
  ErrorHandling = '/dev-demo/error-handling',
  EmbeddedApp = '/dev-demo/embedded-app',
  CompliancePage = '/dev-demo/compliance-page',
  CustomLayout = '/dev-demo/custom-layout',
  DynamicTranslation = '/dev-demo/dynamic-translation',
}
